import { render, staticRenderFns } from "./ahTextSwitch.vue?vue&type=template&id=746942b6&"
import script from "./ahTextSwitch.vue?vue&type=script&lang=js&"
export * from "./ahTextSwitch.vue?vue&type=script&lang=js&"
import style0 from "./ahTextSwitch.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports